import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["template", "rows"]

  add() {
    if (!this.hasTemplateTarget || !this.hasRowsTarget) {
      return
    }

    const index = Date.now()
    const html = this.templateTarget.innerHTML.replaceAll("__INDEX__", index)
    this.rowsTarget.insertAdjacentHTML("beforeend", html)
  }

  remove(event) {
    const row = event.currentTarget.closest("[data-filter-variable-rows-target='row']")
    if (row) {
      row.remove()
    }
  }
}
